function parameterSelectDirective() {
	return {
		scope : {
			category : '=?',
			type : '=?',
			parameter: '=',
			onParameterChange: '&',
			idparent : '=?',
			required:'@?'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/parameterSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'parameterService', function($scope, $window, alertService, parameterService) {
			$scope.valueWasChangedFromSelector = false;
			$scope.availableParameters = [];
			$scope.isRequired = !angular.isUndefined($scope.required);
			
			$scope.searchParameters = function(query) {
				var filter = {
				};
				
				if(query){
					filter.name = query;
					filter.value = query;
				}
				
				if($scope.type){
					filter.type = $scope.type;
				}
				
				if($scope.idparent){
					filter.parent = $scope.idparent;						
				}
				parameterService.searchParameters(filter).then(function(response) {
					$scope.availableParameters = response.getData().results;
                }, function(response) {
                	//on error
                });
			};
			
			 $scope.parameterChanged = function(parameter) {
                $scope.valueWasChangedFromSelector = true;
                if($scope.onParameterChange != undefined){
                    $scope.onParameterChange({parameterSelected: parameter});
                }
            };
            
            $scope.$watch('idparent', function(newValue, oldValue){
            	$scope.searchParameters();
            });
            

		} ],
		link : function(scope, elem, attr) {
			
		}
	};
};

module.directive('parameterSelect', [ parameterSelectDirective ]);